var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className},[_c('a',{class:_vm.anchorClass,attrs:{"href":_vm.href,"role":"tab"}},[(_vm.icon)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }